import React, { useState } from 'react';
import { eCommentType } from 'types/order/comment/eCommentType';
import { IconType, ISelectOption, RotatingIcon, Select } from 'ui-toolkit';

export type onEditCommentTypeSignature = ({
  commentId,
  commentType,
}: {
  commentId: string;
  commentType: eCommentType;
}) => Promise<void>;

export interface IEditCommentTypeProps {
  commentId: string;
  commentType: eCommentType;
  commentTypeOptions: ISelectOption<eCommentType>[];
  onEditCommentType: onEditCommentTypeSignature;
}

export const EditCommentType: React.FC<IEditCommentTypeProps> = ({
  commentId,
  commentType,
  commentTypeOptions,
  onEditCommentType,
}) => {
  const [working, setWorking] = useState(false);

  const onChange = async (keyValue: { key: string; value: eCommentType }) => {
    setWorking(true);
    await onEditCommentType({ commentId, commentType: keyValue.value });
    setWorking(false);
  };
  return (
    <>
      {working ? (
        <RotatingIcon type={IconType.Loading} />
      ) : (
        <Select
          value={commentTypeOptions.find((t) => t.value === commentType)}
          options={commentTypeOptions}
          onChange={onChange}
        />
      )}
    </>
  );
};
